import { clear } from "../lib/dom";
import { onRoute, type Route } from "./router";
import { homeScreen, type Screen } from "./home";
import { levelSelectScreen } from "./levelselect";
import { playScreen } from "./play";
import { settingsScreen } from "./settings";
import { shopScreen } from "./shop";

export function mountShell(appRoot: HTMLElement): void {
  let current: Screen | null = null;

  function show(route: Route): void {
    current?.destroy?.();
    clear(appRoot);

    let screen: Screen;
    switch (route.name) {
      case "game":
        screen = levelSelectScreen(route.gameId!);
        break;
      case "play":
        screen = playScreen(route.gameId!, route.level ?? 1);
        break;
      case "settings":
        screen = settingsScreen();
        break;
      case "shop":
        screen = shopScreen();
        break;
      case "home":
      default:
        screen = homeScreen();
        break;
    }
    current = screen;
    appRoot.append(screen.node);
    // Scroll back to top on navigation.
    appRoot.scrollTop = 0;
  }

  onRoute(show);
}
